<template>
  <div
    class="packages"
    :class="{
      'packages_mobile': isMobile,
    }"
  >
    <div
      v-for="(item, key) in packages"
      :key="key"
      class="packages__item">
      <div class="packages__month">{{ item.month_count }} {{ $tc('msg.monthTc', item.month_count) }}</div>
      <div class="packages__percent">{{ item.percent }}%</div>
      <div class="packages__sale">{{ $t('msg.sale').toLowerCase() }}</div>
      <div class="packages__price">{{ item.price }} ₽</div>
      <div class="packages__benefit">
        <template v-if="item.month_count !== 1">
          {{ $t('msg.perMonth') }}&nbsp;<b>{{ Math.round(item.price / item.month_count) }} ₽</b>
        </template>
      </div>
      <div v-if="!withOutBtns" class="packages__btn">
        <v-btn
          color="primary"
          @click="pay(item.id)"
          elevation="0"
        >{{ $t('msg.pay') }}</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    action: {type: String, required: true},
    withOutBtns: {type: Boolean, default: false},
  },
  data() {
    return {
      packages: [],
    };
  },
  methods: {
    loadPackages() {
      this.$store.dispatch(this.action)
        .then(res => this.packages = res);
    },
    pay(packageId) {
      this.$store.dispatch('getPaymentLink', {data: {package_id: packageId}})
        .then(res => {
          document.location = res.payment_link;
        });
    }
  },
  created() {
    this.loadPackages();
  }
}
</script>

<style lang="scss">
.packages {
  width: calc(100% + 20px);
  margin-left: -10px;
  display: flex;

  &.packages_mobile {
    flex-direction: column;
    align-items: center;

    .packages__item {
      width: 220px;
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }
  .packages__item {
    width: 180px;
    background-color: #fff;
    border-radius: 10px;
    padding: 10px;
    margin: 0 10px 10px 10px;
    box-shadow: 0 8px 40px rgb(177 177 178 / 35%);
  }
  .packages__month {
    padding: 10px 0;
    display: flex;
    justify-content: center;
    font-size: 20px;
    font-weight: 300;
  }
  .packages__percent {
    display: flex;
    justify-content: center;
    font-size: 30px;
    font-weight: 500;
    line-height: 24px;
    color: #535d72;
    padding-top: 10px;
  }
  .packages__sale {
    display: flex;
    justify-content: center;
    color: #535d72;
  }
  .packages__price {
    display: flex;
    justify-content: center;
    font-size: 20px;
    padding: 15px 0 10px;
  }
  .packages__benefit {
    height: 41px;
    display: flex;
    justify-content: center;
    padding: 5px 0 15px 0;
  }
  .packages__btn {
    display: flex;
    justify-content: center;
    padding-bottom: 10px;
  }
}
</style>